import { GeneratePlacementResponse, PlacementContentDef } from '@ads-ep/fetch-api-client';

export function getContentById(contentId: string, brandPresentmentConfig: GeneratePlacementResponse): PlacementContentDef {
  const contentIds = brandPresentmentConfig.placementContent.filter(content=> content.id === contentId);
  return contentIds[0];
}
